import React, { useState, useEffect } from "react";
import ContainerBody from "../components/ContainerBody";
import ContainerNav from "../components/ContainerNav";
import ButtonLink from "../components/ButtonLink";
import { useNavigate } from "react-router-dom";
import { Button, CircularProgress, Typography } from "@mui/material";
import { UploadImageToS3 } from "../utils/UploadImageToS3";
import { v4 as uuidv4 } from "uuid";
import ContainerRoot from "../components/ContainerRoot";
import Switch from "@mui/material/Switch";
import { useTranslation } from "react-i18next";

import {
  ReceiveMessageCommand,
  DeleteMessageCommand,
  SQSClient,
} from "@aws-sdk/client-sqs";

const REGION = "eu-central-1"; //e.g. "us-east-1"

const sqs = new SQSClient({
  region: REGION,
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_API_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_API_SECRET,
  },
});

export default function DebugAllStates(props) {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(props.language);
  }, [i18n, props.language]);

  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [debugMode, setDebugMode] = useState(false);
  const [translatedPrompt, setTranslatedPrompt] = useState("");
  const guid = uuidv4();
  // const [resultImages, setResultImages] = React.useState([]);
  const navigate = useNavigate();

  async function getResult() {
    const params = {
      QueueUrl:
        "https://sqs.eu-central-1.amazonaws.com/801129642390/output-queue",
      MaxNumberOfMessages: 1,
      WaitTimeSeconds: 20,
    };

    let intervalId;

    function stopPolling() {
      clearInterval(intervalId);
    }

    intervalId = setInterval(async () => {
      const data = await sqs.send(new ReceiveMessageCommand(params));
      if (data.Messages && guid === JSON.parse(data.Messages[0].Body)["guid"]) {
        console.log("Message received:", data.Messages[0].Body);
        console.log("URLs:", JSON.parse(data.Messages[0].Body)["urls"]);
        // add message to state
        setMessages((messages) => [...messages, data.Messages[0].Body]);
        setMessages((messages) => [
          ...messages,
          JSON.parse(data.Messages[0].Body)["urls"],
        ]);

        props.setResult(JSON.parse(data.Messages[0].Body)["urls"]);

        const deleteParams = {
          QueueUrl:
            "https://sqs.eu-central-1.amazonaws.com/801129642390/output-queue",
          ReceiptHandle: data.Messages[0].ReceiptHandle,
        };
        await sqs.send(new DeleteMessageCommand(deleteParams)).then(() => {
          console.log("Message deleted");
          setMessages((messages) => [...messages, "Message deleted"]);
        });

        navigate("/result");
        stopPolling();
      } else {
        console.log("No messages in queue");
        setMessages((messages) => [...messages, "No messages in queue"]);
      }
    }, 5000);
  }

  async function handleImageUpload(image) {
    console.log("handleImageUpload", image);
    const data = await UploadImageToS3(image, guid);
    console.log(data);
  }

  async function translateText(text, target) {
    const url = "https://translation.googleapis.com/language/translate/v2";

    const encodedParams = new URLSearchParams();
    encodedParams.append("q", props.prompt.prompt);
    encodedParams.append("target", "en");
    encodedParams.append("format", "text");
    encodedParams.append("key", process.env.REACT_APP_TRANSLATE_API_KEY);
    const options = {
      method: "POST",
      body: encodedParams,
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();
      const result_translate = data.data.translations[0].translatedText;
      console.log("result_translate", result_translate);
      return result_translate;
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    async function getData() {
      const result_translate = await translateText();
      setTranslatedPrompt(result_translate);
    }

    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function handleSubmit(props) {
    console.log("handleSubmit", props);

    invokeLambda();

    // Six string below are prod code TODO:
    setLoading(true);
    props.setGuid(guid);
    const data = await handleImageUpload(props.image);
    console.log(data);
    getResult();
    // Stop prod code
  }

  async function invokeLambda() {
    const formData = {
      guid: guid,
      parameters: props.parameters,
      hardPrompts: props.hardPrompts,
      prompt: props.prompt,
    };

    console.log("prompt in lambda", translatedPrompt);
    // TODO: good till the end of the function
    await fetch(
      "https://kufxhf6q22.execute-api.eu-central-1.amazonaws.com/Prod/run/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
        timeout: 120000,
      }
    )
      .then((data) => {
        console.log("Success from lambda:", data);
        setMessages((messages) => [...messages, "Success from lambda"]);
      })
      .catch((error) => {
        console.error(error);
        setMessages((messages) => [...messages, "Error from lambda"]);
        // handle the error
      });
  }

  function MessageList(props) {
    return (
      <div style={{ height: "200px", overflow: "auto" }}>
        {props.messages.map((message, index) => (
          <div key={index}>{message}</div>
        ))}
      </div>
    );
  }

  const handleToggleSwitch = () => {
    setDebugMode(!debugMode);
  };

  const interiorDesignFacts = [
    t("Facts.1"),
    t("Facts.2"),
    t("Facts.3"),
    t("Facts.4"),
    t("Facts.5"),
    t("Facts.6"),
    t("Facts.7"),
    t("Facts.8"),
    t("Facts.9"),
    t("Facts.10"),
    t("Facts.11"),
    t("Facts.12"),
    t("Facts.13"),
    t("Facts.14"),
    t("Facts.15"),
    t("Facts.16"),
    t("Facts.17"),
    t("Facts.18"),
    t("Facts.19"),
    t("Facts.20"),
  ];

  return (
    <ContainerRoot>
      <div style={{ position: "absolute", top: 0, right: 0, margin: "5px" }}>
        <Typography>Debug</Typography>
        <Switch checked={debugMode} onChange={handleToggleSwitch} />
      </div>
      <ContainerBody>
        {!loading ? (
          <Typography variant="h4" component="h1" gutterBottom>
            {t("Press GO!")}
          </Typography>
        ) : null}
        {loading === true && <CircularProgress />}
        {loading === true ? (
          debugMode === true ? (
            <MessageList messages={messages} />
          ) : (
            <div style={{ justifyContent: "center", alignItems: "center" }}>
              {/* Random fact from interiorDesignFacts */}
              <Typography variant="h6" component="h2" gutterBottom>
                {
                  interiorDesignFacts[
                    Math.floor(Math.random() * interiorDesignFacts.length)
                  ]
                }
              </Typography>
            </div>
          )
        ) : null}
      </ContainerBody>
      <ContainerNav>
        <ButtonLink url="/prompt" title={t("Back")} />
        <ButtonLink url="/" title={t("Restart")} />
        {!loading ? (
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSubmit(props)}
          >
            {t("Go")}
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            disabled
            onClick={() => handleSubmit(props)}
          >
            {t("Go")}
          </Button>
        )}
      </ContainerNav>
    </ContainerRoot>
  );
}

// parameters: {"guessMode":false,"ddimSteps":15,"seed":0,"strength":0.1,"valueThreshold":0.1,"imageResolution":512,"detectResolution":512,"distanceThreshold":0.1,"scale":9,"eta":0}
